/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `typosquatting` - Typosquatting
 * * `brand_infringement` - Brand Infringement
 * * `phishing` - Phishing Domains
 * @export
 */
export const DomainThreatThreatTypeEnum = {
    Typosquatting: 'typosquatting',
    BrandInfringement: 'brand_infringement',
    Phishing: 'phishing'
} as const;
export type DomainThreatThreatTypeEnum = typeof DomainThreatThreatTypeEnum[keyof typeof DomainThreatThreatTypeEnum];


export function instanceOfDomainThreatThreatTypeEnum(value: any): boolean {
    for (const key in DomainThreatThreatTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(DomainThreatThreatTypeEnum, key)) {
            if (DomainThreatThreatTypeEnum[key as keyof typeof DomainThreatThreatTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DomainThreatThreatTypeEnumFromJSON(json: any): DomainThreatThreatTypeEnum {
    return DomainThreatThreatTypeEnumFromJSONTyped(json, false);
}

export function DomainThreatThreatTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainThreatThreatTypeEnum {
    return json as DomainThreatThreatTypeEnum;
}

export function DomainThreatThreatTypeEnumToJSON(value?: DomainThreatThreatTypeEnum | null): any {
    return value as any;
}

export function DomainThreatThreatTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DomainThreatThreatTypeEnum {
    return value as DomainThreatThreatTypeEnum;
}

